/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Platforms_LabelInputs */

const en_fc_cmp_platforms_label = /** @type {(inputs: Fc_Cmp_Platforms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop platforms`)
};

/**
* | output |
* | --- |
* | "Desktop platforms" |
*
* @param {Fc_Cmp_Platforms_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_platforms_label = /** @type {((inputs?: Fc_Cmp_Platforms_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Platforms_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_platforms_label(inputs)
});
export { fc_cmp_platforms_label as "fc.cmp.platforms.label" }